






import LegacySearchService from '~/services/search/LegacySearchService'
import BaseSearchHandler from '~/components/car/classifieds/search/facets/handlers/BaseSearchHandler.vue'
import ColorValueSearchHandler from '~/components/car/classifieds/search/facets/handlers/ColorValueSearchHandler.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { ColorValueSearchHandler },
  extends: BaseSearchHandler,
  computed: {
    blackCheckmarksColorsIds() {
      return [5, 6, 1]
    },
    legacySearchService() {
      return this.$dep(LegacySearchService)
    }
  },
  methods: {
    hasBlackCheckmark(optionId: string): boolean {
      return this.blackCheckmarksColorsIds.includes(Number(optionId))
    }
  }
})
